import { FlagIcon } from '@evimo/components/flagIcon/FlagIcon';
import { LanguageSwitcher } from '@evimo/components/LanguageSwitcher/LanguageSwitcher';
import { useLanguageSwitcher } from '@evimo/hooks/useLanguageSwitcher';
import { LanguageSwitcherCompProps } from '~/app/components/LanguageSwitcher/LanguageSwitcher.types';

export const LanguageSwitcherContainer = (props: LanguageSwitcherCompProps) => {
  const { currentLanguage, items, handleMenuClick } = useLanguageSwitcher();

  return (
    <LanguageSwitcher
      currentLanguage={currentLanguage}
      items={items}
      withinMenu={props.withinMenu}
      collapsed={props.collapsed}
      onMenuClick={handleMenuClick}
      flag={
        <FlagIcon
          language={currentLanguage}
          size={props?.withinMenu ? 35 : 24}
        />
      }
    />
  );
};
